import React from 'react';

import { Chip } from '@mui/material';

export default function ManualChip() {
  return <Chip label="Manual" size="small" color="success" variant="outlined" sx={{ height: 20, fontSize: 11 }} />;
}
